import * as React from 'react'

const createMarkup = (markup: string = '') => {
  // TODO: REMOVE THIS ONCE ALL TYPESCRIPT
  if (typeof markup !== 'string') {
    throw new Error('must have a single html string as a child.')
  }
  return { __html: `${markup}` }
}

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  children: string
}

const DangerouslySetInnerHtml = ({ className, children }: IProps) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={createMarkup(children)}
    />
  )
}

export default DangerouslySetInnerHtml



// WEBPACK FOOTER //
// ./client/components/dangerouslySetInnerHtml.tsx